<template>
  <div class="w-screen h-90vh relative">
    <div class="w-full h-1">
      <span @click="gotoListTemplate" class="float-right mr-8 mt-2 cursor-pointer" style="width: 48px; height: 48px;">
        <svg data-v-60dee950="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="window-close" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-window-close fa-w-16 fa-3x"><path data-v-60dee950="" fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z" class=""></path></svg>
      </span>
    </div>
    <div class="w-full">
      <h2 class="text-center mt-12 fz-24">テンプレートの作成</h2>
    </div>
    <div class="item-center w-1/2">
      <div class="item-center flex">
        <div @click="drawer = true" class="flex cursor-pointer bg-red-200 w-64 h-72 relative border-2 hover:border-blue-300">
          <el-button class="item-center text-gray-500" style="padding: 3px 0" type="text">
            新しい書類画像から
          </el-button>
        </div>
        <div class="flex cursor-pointer bg-yellow-200 w-64 h-72 relative border-2 hover:border-blue-300">
          <el-button class="item-center text-gray-500" style="padding: 3px 0" type="text">
            XML設定ファイルから
          </el-button>
        </div>
      </div>
    </div>

    <el-drawer
      title="The title"
      :visible.sync="drawer"
      :direction="direction"
      :with-header="false"
      size="50%"
      :before-close="handleClose">
      <div class="w-full h-full text-center flex justify-center pt-3">
        <div class="text-center w-1/2">
          <h3>新しい書類画像のファイルを選んでください</h3>
          <div class="modal-content w-full">
            <ValidationObserver v-slot="{ invalid }">
            <form>
              <ValidationProvider
                name="ファイル"
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
                class=""
              >
              <el-button @click="selectFile" class="w-2/5 mt-4 mb-1" type="info">ファイルを選択</el-button>
              <div class="mt-4"><span class="text-red-500">{{ errors[0] }}</span></div>
              <input type="file" @change="chooseFile" ref="selectFile" class="hidden"/>
              </ValidationProvider>

              <div class="text-gray-400">{{ file_name }}</div>
              <h4 class="mt-3">テンプレート名を入力してください</h4>
              <ValidationProvider
                name="テンプレート名"
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
                class=""
              >
              <div class="mt-4"><el-input placeholder=" テンプレート名" class="w-2/5" v-model="template.name"></el-input></div>
              <div class="mt-4"><span class="text-red-500">{{ errors[0] }}</span></div>
              </ValidationProvider>
              <div class="mt-3"><el-button @click="create" class="w-2/5" type="primary" :disabled="invalid">作成</el-button></div>
            </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      drawer: false,
      direction: 'btt',
      input: "",
      file_name: '',
      template: {
        id: "",
        name: "",
        collection_id: "",
        upload_file: "",
        boxes: [
          {
            title: "",
            start_x: "",
            start_y: "",
            end_x: "",
            end_y: "",
            charset: "",
            n_lines: "",
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions('template', ['createTemplate', 'getTemplates']),
    handleClose(done) {
      this.$confirm(`テンプレートの作成をキャンセルしますか？`, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
      })
      .then(() => {
        done();
      })
      .catch(() => {});
    },
    selectFile: function() {
      this.$refs.selectFile.click();
    },
    create: async function() {
      var formData = new FormData()
      for( var key in this.template ) {
        formData.append(key, this.template[key]);
      }
      let response = await this.createTemplate(formData);
      await this.getTemplates(this.template.collection_id);
      if(response) {
        this.$router.push({
          name: 'template.edit',
          params: {
            id: response.id,
          }
        })
      }
    },
    chooseFile: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.template.upload_file = files[0];
      this.file_name = this.template.upload_file.name;
    },
    gotoListTemplate: function() {
      this.$router.push({
        name: 'templates',
      })
    },
  },
  created: function() {
    let collectionActiveId = this.$router.app._route.query.collectionActiveId;
    if(collectionActiveId) {
      this.template.collection_id = collectionActiveId;
    }
  }
};
</script>

<style>
.item-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fz-24 {
  font-size: 24px;
}
</style>